(() => {
  const initialize = (root) => {
    if (root.dataset.bullionReady) return;
    root.dataset.bullionReady = 'true';
    const variantSelect = root.querySelector('select[name="id"]');
    variantSelect?.addEventListener('change', () => {
      const url = new URL(location.href);
      url.searchParams.set('variant', variantSelect.value);
      location.assign(url.href);
    });
    const purchaseForm = root.querySelector('.custom-coin-product__form');
    const sticky = root.querySelector('.bullion-sticky');
    if (purchaseForm && sticky && 'IntersectionObserver' in window) {
      const observer = new IntersectionObserver(([entry]) => { sticky.hidden = entry.isIntersecting; });
      observer.observe(purchaseForm);
    }

    // Legacy catalog descriptions contain specifications separated by <br>.
    // Keep those facts once, while retaining prose and unrecognized content.
    const description = root.querySelector('[data-spec-source]') || root.querySelector('[data-product-description]');
    const specs = root.querySelector('[data-structured-specs]');
    const specCard = root.querySelector('.custom-coin-product__spec-card');
    const empty = root.querySelector('[data-spec-empty]');
    if (description && specs) {
      const copy = description.cloneNode(true);
      copy.querySelectorAll('br').forEach((br) => br.replaceWith('\n'));
      copy.querySelectorAll('p,li,h2,h3,h4,tr').forEach((node) => node.append('\n'));
      const lines = copy.textContent.split('\n').map((line) => line.trim()).filter(Boolean);
      const known = /^(metal|metal type|year|condition|purity|denomination|face value|actual weight|fine weight|gross weight|weight|diameter|thickness|origin|country|mint|packaging|grade|grading|ira approved)\s*:\s*(.+)$/i;
      const matched = lines.map((line) => line.match(known)).filter(Boolean);
      if (matched.length >= 3) {
        const existing = new Set([...specs.querySelectorAll('dt')].map((node) => node.textContent.toLowerCase()));
        for (const match of matched) {
          if (existing.has(match[1].toLowerCase())) continue;
          const row = document.createElement('div');
          const term = document.createElement('dt');
          const value = document.createElement('dd');
          term.textContent = match[1];
          value.textContent = match[2];
          row.append(term, value);
          specs.append(row);
          existing.add(match[1].toLowerCase());
        }
        const prose = lines.filter((line) => !known.test(line) && !/^product specifications:?$/i.test(line));
        if (prose.length === 0) {
          description.replaceChildren();
          const heading = document.createElement('h2');
          heading.textContent = 'About this coin';
          const paragraph = document.createElement('p');
          paragraph.textContent = `${root.querySelector('h1').textContent.trim()}. Review the listed weight, purity and condition in the specifications above. For details about packaging or a particular coin, contact us before ordering.`;
          description.append(heading, paragraph);
        }
      }
      if (empty) empty.hidden = specs.children.length > 0;
      specs.hidden = specs.children.length === 0;
      if (specCard) specCard.hidden = specs.children.length === 0;
    }

    const tabs = [...root.querySelectorAll('[data-product-tab]')];
    tabs.forEach((tab, index) => {
      const panel = root.querySelector(`[data-product-panel="${tab.dataset.productTab}"]`);
      tab.id = `bullion-tab-${root.dataset.customCoinProduct}-${index}`;
      tab.tabIndex = index === 0 ? 0 : -1;
      if (panel) {
        panel.id = `${tab.id}-panel`;
        tab.setAttribute('aria-controls', panel.id);
        panel.setAttribute('aria-labelledby', tab.id);
      }
      tab.addEventListener('click', () => tabs.forEach((item) => { item.tabIndex = item === tab ? 0 : -1; }));
      tab.addEventListener('keydown', (event) => {
        let next;
        if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
        if (event.key === 'ArrowLeft') next = (index + tabs.length - 1) % tabs.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = tabs.length - 1;
        if (next !== undefined) { event.preventDefault(); tabs[next].focus(); tabs[next].click(); }
      });
    });

  };
  const initializeAll = () => document.querySelectorAll('[data-bullion-product]').forEach(initialize);
  initializeAll();
  document.addEventListener('shopify:section:load', initializeAll);
})();
